import React from 'react';
import { IProps, IStepElems } from './types';

const ProcessBar: React.FC<IProps> = (props) => (
  <div className={`process-bar process-bar--${props.insType}`}>
    {props.stepElems.map((stepElem: IStepElems, index: number) => {
      const activeClassname = stepElem.active ? ' process-bar__item--active' : '';
      const mobileActiveClassname = stepElem.mobileActive ? ' process-bar__item--mobile-active' : '';
      const iconClassname = stepElem.icon && ` process-bar__item-icon--${stepElem.icon}`;
      return (
        <div className={`process-bar__item${activeClassname}${mobileActiveClassname}`} key={index}>
          <div className={`process-bar__item-icon${iconClassname}`} />
          <span>{stepElem.text}</span>
        </div>
      );
    })}
  </div>
);

export default ProcessBar;
